module.exports = __webpack_public_path__ + "img/blend1icon2.a4b5465c.png";